<template>
    <layout
        :showuserinfo="false"
        :title="'Cukai Tanah: ' + this.noHm"
        :crumbs="crumbs"
    >
        <w-button class="mb3" text @click="kembali()">
            &#60;&#60; Kembali
        </w-button>
        <!---->
        <z-page class="" title="Butiran Hak Milik">
            <hakmilik :cukai="culai" />
        </z-page>
        <!---->

        <!---->
        <z-page class="mt3" title="Daftar Pengecualian" :append-button="true">
            <w-form @submit.prevent="submit">
                <w-flex class="mt3">
                    <div class="xs6 mr3">
                        <w-input
                            placeholder="Sila Masukkan No. MMK"
                            v-model="form.no_mknk"
                            >No. MKNK</w-input
                        >
                    </div>


                    <div class="xs6 mr3">
                        <w-input type="date" v-model="form.tarikh_mula"
                            >Tarikh Mula</w-input
                        >
                    </div>

                </w-flex>

                <div class="d-flex justify-end mt3">
                    <w-button class="my1 mr0" type="submit"
                        >Daftar Pengecualian</w-button
                    >
                </div>
            </w-form>
        </z-page>

        <z-page class="mt3" title="Butiran Pengecualian" :append-button="true">
            <Table
                :headers="pengecualian.headers"
                :items="pengecualian.items"
                :loading="loading"
            >
                <template
                    #item-cell.tarikh_mula="{ item, label, header, index }"
                >
                    {{ moment(item.tarikh_mula).format("DD-MM-YYYY") }}
                </template>

                <template
                    #item-cell.tarikh_tamat="{ item, label, header, index }"
                >
                    {{ moment(item.tarikh_tamat).format("DD-MM-YYYY") }}
                </template>
                <template #item-cell.action="{ item, label, header, index }">
                    <inertia-link
                        :href="$route('cukai-tanah.kemasPengecualian')"
                        :data="{ no_mknk: item.no_mknk }"
                    >
                        <w-tooltip top>
                            <template #activator="{ on }">
                                <w-icon v-on="on"> fal fa-pencil </w-icon>
                            </template>
                            Kemaskini
                        </w-tooltip>
                    </inertia-link>
                </template>
            </Table>
        </z-page>
        <!---->
    </layout>
</template>

<script>
import ZResource from "@/Modules/z-resource";
import Hakmilik from "../Component/Hakmilik";
import { Inertia } from "@inertiajs/inertia";
import moment from "moment";
import Table from "../Component/Table";

export default {
    extends: ZResource,
    props: {
        noHm: [Object],
    },
    components: {
        Hakmilik,
        Table,
    },
    data() {
        return {
            resourceurl: "cukai-tanah",
            apiBaseUrl: process.env.MIX_API_BASE_URL,
            reload: true,
            loading: true,
            registering: false,
            crumbs: [
                { label: this.$page.props.app_name, route: "/sitemap" },
                { label: "Cukai Tanah", route: "/cukai-tanah/dashboard" },
                { label: "Senarai", route: "/cukai-tanah/senarai" },
            ],
            pemiliks: [{ label: "Loading", selected: true }],
            form: {
                keluasan: null,
                hm_akaun_id: null,
                no_mknk: null,
                tarikh_mula: null,
                status: 1,
            },
            culai: [],
            pengecualian: {
                headers: [
                    { label: "Bil", key: "id" },
                    { label: "No. MKNK", key: "no_mknk" },
                    //   { label: "Nama", key: "pemilik" },
                    //   { label: "No. Akaun", key: "no_akaun" },
                    { label: "Tempoh Mula", key: "tarikh_mula" },
                    { label: "Status", key: "status" },
                    { label: "Tindakan", key: "action", align: "center" },
                ],
                items: [],
            },
        };
    },
    methods: {
        async submit() {
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/pengecualian`,
                responseType: "json",
                data: this.form,
            })
                .then((e) => {
                    if (e.data.length > 0) {
                        window.location.reload();
                    }
                })
                .finally((e) => {
                    this.fetchData2();
                    this.registering = false;
                    this.$waveui.notify({
                        success: true,
                        message: "BERJAYA",
                        timeout: 3000,
                    });
                });
        },
        async getPengecualian() {
            const l = {
                kategoriCarian: "1",
                formOption: "option1",
                kod_daerah: "02",
                barcode: this.noHm,
            };
            await axios({
                method: "post",
                url: `${this.apiBaseUrl}/cukai/cari`,
                responseType: "json",
                data: l,
            }).then((e) => {
                if (e.data.length > 0) {
                    this.form.keluasan = e.data[0].keluasan;
                    this.form.hm_akaun_id = e.data[0].id;
                    this.culai = e.data[0];
                }
            });
        },
        async fetchData2() {
            await axios({
                method: "get",
                url: `${this.apiBaseUrl}/cukai/pengecualian?no_hm=${this.noHm}&limit=10&offset=0`,
                params: this.searchParams,
                responseType: "json",
            })
                .then((e) => {
                    const { data, limit, offset, total } = e.data;
                    this.pengecualian.items = data;
                    // this.pengecualian.items = e.data.data.map((d) => {
                    //   return {
                    //     id: d.id,
                    //     no_mknk: d.no_mknk,
                    //     action: d.id,
                    //     tempoh_mula: moment(d.tarikh_mula).format("DD-MM-YYYY"),
                    //     tempoh_tamat: moment(d.tarikh_tamat).format("DD-MM-YYYY"),
                    //     amaun: d.amaun,
                    //     status: d.status,
                    //   };
                    // });
                })
                .finally((_) => {
                    this.loading = false;
                });
        },
        kembali() {
            window.history.back();
        },
        moment(date) {
            return moment(date);
        },
    },
    watch: {},
    computed: {
        moment: () => moment,
    },

    mounted() {
        // override default setting
        this.getPengecualian();
        this.fetchData2();
        this.dialog.width = 500;
    },
};
</script>
